import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (p) => (p ? (p.startsWith("http") || p.startsWith("/") ? p : `${API}/files/${p}`) : "");

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan, coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const rupiah = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");
export const publicShopUrl = (slug) => `${window.location.origin}/${slug}`;
export const slugify = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 30);

export function trackClick(product_id, type) {
  fetch(`${API}/public/click`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product_id, type }),
    keepalive: true,
  }).catch(() => {});
}

export const SHOP_CATEGORIES = [
  "Fashion", "Kecantikan", "Elektronik", "Rumah Tangga", "Makanan & Minuman",
  "Ibu & Bayi", "Olahraga", "Hobi", "Kesehatan", "Lainnya",
];
